import styles from './GameRatingModal.module.css'
import classNames from 'classnames'
import { useField } from 'react-final-form'

type StarRatingButtonsProps = {
  setValue: number
}

export const StarRatingButtons: React.FC<StarRatingButtonsProps> = ({ setValue }) => {
  const { input } = useField('stars')

  const handleSaveStarRating = (value: number) => {
    input.onChange(value)
  }

  return (
    <>
      <div className={styles.ratingStars}>
        <button
          type='button'
          name='stars'
          className={classNames(styles.star, input.value >= 5 ? styles.starFilled : styles.starEmpty)}
          onClick={() => handleSaveStarRating(5)}
        />
        <button
          type='button'
          name='stars'
          className={classNames(styles.star, input.value >= 4 ? styles.starFilled : styles.starEmpty)}
          onClick={() => handleSaveStarRating(4)}
        />
        <button
          type='button'
          name='stars'
          className={classNames(styles.star, input.value >= 3 ? styles.starFilled : styles.starEmpty)}
          onClick={() => handleSaveStarRating(3)}
        />
        <button
          type='button'
          name='stars'
          className={classNames(styles.star, input.value >= 2 ? styles.starFilled : styles.starEmpty)}
          onClick={() => handleSaveStarRating(2)}
        />
        <button
          type='button'
          name='stars'
          className={classNames(styles.star, input.value >= 1 ? styles.starFilled : styles.starEmpty)}
          onClick={() => handleSaveStarRating(1)}
        />
      </div>
    </>
  )
}
